import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetNewsAndEventsDetailSlice = createSlice({
    name: "getNewsAndEventsDetail",
    initialState,
    reducers: {
        getNewsAndEventsDetailRequest(state) {
            state.loading = true;
        },
        getNewsAndEventsDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getNewsAndEventsDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getNewsAndEventsDetailRequest,
    getNewsAndEventsDetailRequestSuccess,
    getNewsAndEventsDetailRequestError,
} = GetNewsAndEventsDetailSlice.actions;

export default GetNewsAndEventsDetailSlice.reducer;
